export const showMoreFilters = ({ dimensions = [], breadCrumbs = [] }) => {
  const dimensionCategories = dimensions.filter((dimension) => (dimension.label || '').toUpperCase() === 'CATEGORY');
  const breadCrumbsCategories = breadCrumbs.filter((breadCrumb) => (breadCrumb.dimensionName || '')
  && breadCrumb.dimensionName.toUpperCase() === 'CATEGORY');

  if ((breadCrumbsCategories === undefined || breadCrumbsCategories.length === 0)
  && (dimensionCategories !== undefined && dimensionCategories.length === 1)) {
    return true;
  }
  return false;
};

export const RATINGS_REFINEMENT_KEY = 'bwo5q';

export const getNavParam = ({ nValue, breadCrumbs }) => {
  if (nValue) {
    return nValue.trim();
  }
  if (breadCrumbs) {
    const breadCrumbsCategories = (breadCrumbs.filter((breadCrumb) => (breadCrumb.dimensionName || '') && breadCrumb.dimensionName === 'Category')); // eslint-disable-line max-len

    const { url } = breadCrumbsCategories.pop() || {};

    if (!url) return null;

    return /\/N-(\w+)/.exec(url)[1];
  }
  return null;
};

export const getLoadingState = ({ data, loading, props, prevProps }) => {
  const varChange = (prevProps?.navParam !== props?.navParam)
    || (prevProps?.keyword !== props?.keyword)
    || (prevProps?.nao !== props?.nao)
    || (prevProps?.sortby !== props?.sortby)
    || (prevProps?.sortorder !== props?.sortorder)
    || (prevProps?.lowerbound !== props?.lowerbound)
    || (prevProps?.upperbound !== props?.upperbound);

  // loading is false
  if (!loading) return false;

  // loading is true, no data
  if (!data) return true;

  // loading is true, data, variable change
  if (data && varChange) return true;

  return false;
};

export const updateQueryParams = (path, params) => {
  const paramNames = params.map((p) => p.paramName); // eslint-disable-line id-length

  const [pathname, query = ''] = path.split('?');
  const queryParams = query.split('&').filter((p) => p); // eslint-disable-line id-length
  const updatedParams = [
    ...queryParams
      .filter((queryParam) => {
        const parts = queryParam.split('=');
        return paramNames.indexOf(parts[0]) === -1;
      }),
    ...params
      .filter((p) => p.paramValue) // eslint-disable-line id-length
      .map((param) => {
        return `${param.paramName}=${param.paramValue}`;
      })
  ].join('&');
  return pathname + '?' + updatedParams;
};

export const parseUrl = ({ path }) => {
  const parts = path.replace(/^\/render[^/]*/, '').split('?');
  const leftOfQuery = parts[0] || '';
  let queryString = parts[1] || '';

  let [_, context, category, ...pieces] = leftOfQuery.split('/');

  const slugs = [];
  let keyword;
  let nValue;

  if (queryString && (queryString.indexOf('lowerBound') > -1 && queryString.indexOf('upperBound') > -1)) {
    queryString = queryString.replace('lowerBound', 'lowerbound');
    queryString = queryString.replace('upperBound', 'upperbound');
  }

  if (context === 's') {
    keyword = category;
    category = 'search';
  }
  if (/^N-/.test(category)) {
    nValue = category;
    category = null;
  }
  (pieces || []).forEach((piece) => {
    if (!/^Ntt-|^Ntk-|N-5/.test(piece)) {
      slugs.push(piece);
    } else if (/^Ntt-/.test(piece)) {
      keyword = piece.substring(4, piece.length)?.split('%2B').join(' ');
    } else if (/^N-/.test(piece)) {
      nValue = piece.substring(2, piece.length);
    }
  });

  const params = (queryString.match(/(\w+)=([^&]+)/g) || [])
    .map((val) => {
      const param = val.split('=');
      return {
        [param[0]]: param[1]
      };
    })
    .reduce((acc, next) => {
      const key = Object.keys(next)[0];
      return {
        ...acc,
        [key]: next[key]
      };
    }, {});

  if (params.storeIds) {
    params.storeIds = params.storeIds.split(',');
  }

  if (keyword) {
    keyword = decodeURIComponent(keyword);
  }

  return {
    slugs,
    keyword,
    context,
    category,
    nValue,
    ...params
  };
};

export function getClearAllWithSort({ metadata, searchReport }) {
  let url = metadata.clearAllRefinementsURL || '';
  const { sortBy, sortOrder } = searchReport;
  const defaultSortOrder = sortOrder && sortOrder !== 'none' ? sortOrder : 'asc';

  if (defaultSortOrder && sortBy) {
    url += `?sortorder=${defaultSortOrder}&sortby=${sortBy}`;
  }
  return url;
}

const getCategories = (dimensions) => {
  const dimensionCategories = dimensions.filter((dimension) => (dimension.label || '') && (dimension.label.toUpperCase() === 'CATEGORY')); // eslint-disable-line max-len
  if (dimensionCategories === undefined || dimensionCategories.length === 0) {
    return [{ label: 'Category', dimensionId: '2', refinements: [] }];
  }
  return dimensionCategories;
};

export function sortDimensions({ dimensions = [], searchReport = {}, metadata = {}, shiftCategoryDimension = false }) {

  let getItFast = dimensions.filter((dimension) => (dimension.label || '') && (dimension.label.toUpperCase() === 'GET IT FAST')); // eslint-disable-line max-len

  const inStockOnly = dimensions.filter((dimension) => (dimension.label || '') && (dimension.label.toUpperCase() === 'AVAILABILITY')); // eslint-disable-line max-len

  const categories = getCategories(dimensions);

  const topDimensions = dimensions
    .filter((dimension) => dimension.isVisualNav && dimension.label.toUpperCase() !== 'GET IT FAST')
    .sort((dim1, dim2) => dim1.visualNavSequence - dim2.visualNavSequence);

  const moreDimensions = dimensions.filter((dimension) => !dimension.isVisualNav
    && (dimension.label || '')
    && ['GET IT FAST', 'CATEGORY', 'AVAILABILITY'].indexOf(dimension.label.toUpperCase()) === -1);

  if (getItFast && !getItFast.length) {
    getItFast = [{
      label: 'Get It Fast',
      dimensionId: 'fakeDimension',
      refinements: [
        {
          label: 'Pick Up Today',
          recordCount: 0,
          refinementKey: 'fake',
          url: searchReport?.searchUrl || metadata?.canonicalUrl
        }]
    }];
  }
  if (shiftCategoryDimension) {
    return [
      ...categories,
      ...getItFast,
      ...inStockOnly,
      ...topDimensions,
      ...moreDimensions
    ];
  }
  return [
    ...getItFast,
    ...inStockOnly,
    ...categories,
    ...topDimensions,
    ...moreDimensions
  ];
}

export const shouldRenderVisualRefinement = (refinements) => {
  return refinements.every((refinement) => refinement.imgUrl);
};

export function getRefinementUrlWithSort({ dimension, metadata, refinement, searchReport = {} }) {
  const { dimensionId } = dimension;
  let url = refinement?.url?.slice(0);

  if (dimensionId === 'custom_price') {
    const parts = metadata.canonicalUrl.split('?');
    if (parts.length > 1) {
      url = metadata.canonicalUrl + `&upperbound=${refinement.upperbound}&lowerbound=${refinement.lowerbound}`;
    } else {
      url = metadata.canonicalUrl + `?NCNI-5&upperbound=${refinement.upperbound}&lowerbound=${refinement.lowerbound}`;
    }
  }
  if (url && (url.indexOf('lowerBound') > -1 && url.indexOf('upperBound') > -1)) {
    url = url.replace('lowerBound', 'lowerbound');
    url = url.replace('upperBound', 'upperbound');
  }

  const urlParts = url.split('/');
  const lastPart = urlParts.length ? urlParts[urlParts.length - 1] : '';
  const params = lastPart.split('?');
  const refinementParam = params.length > 1 ? params.pop() : null;
  const { sortBy, sortOrder } = searchReport;

  let updatedQuery = '';
  if (sortBy && sortOrder) {
    const isDefaultSort = sortBy === 'topsellers' && sortOrder === 'desc';
    if (!isDefaultSort) {
      updatedQuery = `?sortby=${sortBy}&sortorder=${sortOrder}`;
    }
  } else if (refinementParam) {
    updatedQuery = `?${refinementParam}`;
  }

  let updatedUrl = `${url}${updatedQuery}`;
  if (refinementParam) {
    updatedUrl = `${url}${updatedQuery.replace('?', '&')}`;
  }
  return updatedUrl;
}

export function hasDimensionName(dimensionName) {
  const DIMENSION_NAMES = ['MATERIAL', 'STYLE', 'COLOR', 'PATTERN', 'MEASUREMENTS', 'SIZE'];
  return DIMENSION_NAMES.indexOf(dimensionName) !== -1;
}

export function getBrowseSearchParam(crumbs = []) {
  let filterLabels = '';
  const visNavCategoryMap = new Map();
  let deletedSequences = [];

  const reviewRatings = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase() === 'REVIEW RATING');
  if (reviewRatings.length === 1 && reviewRatings[0].label === '5') {
    filterLabels += 'Best Rated ';
  }

  const visualNavSequences = (crumbs || []).map((crumb) => {
    const dimensionName = (crumb.dimensionName || '').toUpperCase();
    const hasDimName = hasDimensionName(dimensionName);
    if (hasDimName) {
      const hasDupicateDimension = deletedSequences.indexOf(crumb.dimensionName) !== -1;
      if (hasDupicateDimension) {
        if (visNavCategoryMap.size) {
          visNavCategoryMap.delete(crumb.dimensionName);
        }
      } else {
        visNavCategoryMap.set(crumb.dimensionName, crumb.label);
        deletedSequences.push(crumb.dimensionName);
      }
    }
    return visNavCategoryMap;
  });

  // GET THE SIZE NAMES
  const sizeNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('SIZE') !== -1);
  if (sizeNames && sizeNames.length === 1 && filterLabels.indexOf(sizeNames[0].label) === -1) {
    filterLabels += sizeNames[0].label + ' ';
  }

  // GET THE MEASUREMENT NAMES
  const measurments = crumbs
    .filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('MEASUREMENTS') !== -1);
  if (measurments
    && measurments.length === 1
    && filterLabels.indexOf(measurments[0].label) === -1) {
    filterLabels += measurments[0].label + ' ';
  }

  // GET THE SHAPE NAMES
  const shapeNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('SHAPE') !== -1);
  if (shapeNames && shapeNames.length === 1 && filterLabels.indexOf(shapeNames[0].label) === -1) {
    filterLabels += shapeNames[0].label + ' ';
  }

  // GET THE COLOR NAMES
  const colorNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('COLOR') !== -1);
  if (colorNames && colorNames.length === 1 && filterLabels.indexOf(colorNames[0].label) === -1) {
    filterLabels += colorNames[0].label + ' ';
  }

  // GET THE PATTERN NAMES
  const patterns = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('PATTERN') !== -1);
  if (patterns && patterns.length === 1 && filterLabels.indexOf(patterns[0].label) === -1) {
    filterLabels += patterns[0].label + ' ';
  }

  // GET THE STYLE NAMES
  const styleNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('STYLE') !== -1);
  if (styleNames && styleNames.length === 1 && filterLabels.indexOf(styleNames[0].label) === -1) {
    filterLabels += styleNames[0].label + ' ';
  }

  // GET THE MATERIAL LABEL
  const materialNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase().indexOf('MATERIAL') !== -1);
  if (materialNames && materialNames.length === 1 && filterLabels.indexOf(materialNames[0].label)) {
    filterLabels += materialNames[0].label + ' ';
  }

  // GET THE BRAND NAMES
  const brandNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase() === 'BRAND');
  if (brandNames.length === 1 && filterLabels.indexOf(brandNames[0].label)) {
    filterLabels += brandNames[0].label + ' ';
  }

  visNavCategoryMap.forEach((value) => {
    if (filterLabels.indexOf(value) === -1) {
      filterLabels += value + ' ';
    }
  });

  // GET THE CATEGORY NAMES
  const categoryNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase() === 'CATEGORY');
  if (categoryNames.length > 0) {
    filterLabels += (categoryNames[categoryNames.length - 1] || '').label + ' ';
  }

  // GET INSTALLATION DIMENSIONS
  const installationNames = crumbs.filter((crumb) => (crumb.dimensionName || '').toUpperCase() === 'INSTALLATION');
  if (installationNames.length === 1) {
    filterLabels += ' - ' + installationNames[0].label;
  }

  const letUsDoItForYouLabels = crumbs
    .filter((crumb) => (crumb.dimensionName || '').toUpperCase() === 'LET US DO IT FOR YOU');
  if (letUsDoItForYouLabels.length === 1) {
    filterLabels += ' - ' + letUsDoItForYouLabels[0].label;
  }

  return filterLabels;
}

export function getCustomPriceRange(lowerbound, upperbound) {
  let lbound = parseInt(lowerbound, 10) || undefined;
  let ubound = parseInt(upperbound, 10) || undefined;

  lbound = !lbound && !!ubound ? 0 : lbound;
  // pass the ubound as received (undef), if not supplied by user
  ubound = !ubound && !!lbound ? upperbound : ubound;

  if (ubound && lbound > ubound) [lbound, ubound] = [ubound, lbound];
  return { lbound, ubound };
}
